import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { t } from 'i18next'
import { Channel, FETCH_CHANNELS, FETCH_CHANNELS_FAILURE, FETCH_CHANNELS_SUCCESS } from 'src/redux/integrationsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

interface Response {
  channels: Channel[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchChannelsFlow(): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const response: Response = yield call(apiCall, {
      endpoint: '/dealers_api/channels',
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_CHANNELS_SUCCESS({ channels: response.channels }))
  } catch (error) {
    yield put(FETCH_CHANNELS_FAILURE())
    yield put(SHOW_TOAST({ message: t('integrations_screen.load_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchChannelsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_CHANNELS, FetchChannelsFlow)
}
